import React from 'react';
import { Icon } from './Icon.js';
export const IconLabelFilled = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m15.92,5.632l-4-3.333c-1.112-.928-2.729-.928-3.841,0l-4,3.333c-.686.571-1.08,1.411-1.08,2.304v6.063c0,2.206,1.794,4,4,4h6c2.206,0,4-1.794,4-4v-6.063c0-.893-.394-1.733-1.08-2.304Zm-5.92,3.868c-.69,0-1.25-.56-1.25-1.25s.56-1.25,1.25-1.25,1.25.56,1.25,1.25-.56,1.25-1.25,1.25Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconLabelFilled.js.map